module.exports = __webpack_public_path__ + "img/tunisia-flag.8e3c94d9.svg";